module.exports = __webpack_public_path__ + "static/media/eps.3b677fbc.png";